// Mock data for The True Gem Clone

export const products = [
  {
    id: 1,
    name: "Alaniz Solitaire Asscher",
    price: 2075,
    image: "https://images.pexels.com/photos/10976653/pexels-photo-10976653.jpeg?auto=compress&cs=tinysrgb&w=500&h=500&fit=crop",
    category: "Solitaire",
    metal: "18K Yellow Gold",
    shape: "Asscher"
  },
  {
    id: 2,
    name: "Alaniz Solitaire Cushion",
    price: 2075,
    image: "https://images.pexels.com/photos/691046/pexels-photo-691046.jpeg?auto=compress&cs=tinysrgb&w=500&h=500&fit=crop",
    category: "Solitaire",
    metal: "18K Yellow Gold",
    shape: "Cushion"
  },
  {
    id: 3,
    name: "Alaniz Solitaire Oval",
    price: 2075,
    image: "https://images.pexels.com/photos/2735970/pexels-photo-2735970.jpeg?auto=compress&cs=tinysrgb&w=500&h=500&fit=crop",
    category: "Solitaire",
    metal: "18K Yellow Gold",
    shape: "Oval"
  },
  {
    id: 4,
    name: "Araceli Ring Emerald",
    price: 2450,
    image: "https://images.pexels.com/photos/1616096/pexels-photo-1616096.jpeg?auto=compress&cs=tinysrgb&w=500&h=500&fit=crop",
    category: "Embellished",
    metal: "18K Rose Gold",
    shape: "Emerald"
  },
  {
    id: 5,
    name: "Araceli Ring Round",
    price: 2450,
    image: "https://images.pexels.com/photos/2849742/pexels-photo-2849742.jpeg?auto=compress&cs=tinysrgb&w=500&h=500&fit=crop",
    category: "Embellished",
    metal: "18K White Gold",
    shape: "Round"
  },
  {
    id: 6,
    name: "Arden Ring Marquise",
    price: 3950,
    image: "https://images.pexels.com/photos/5370706/pexels-photo-5370706.jpeg?auto=compress&cs=tinysrgb&w=500&h=500&fit=crop",
    category: "Halo",
    metal: "18K Yellow Gold",
    shape: "Marquise"
  },
  {
    id: 7,
    name: "Arden Solitaire Pear",
    price: 2325,
    image: "https://images.pexels.com/photos/371285/pexels-photo-371285.jpeg?auto=compress&cs=tinysrgb&w=500&h=500&fit=crop",
    category: "Solitaire",
    metal: "18K Champagne Gold",
    shape: "Pear"
  },
  {
    id: 8,
    name: "Avery Ring Princess",
    price: 1850,
    image: "https://images.pexels.com/photos/1457801/pexels-photo-1457801.jpeg?auto=compress&cs=tinysrgb&w=500&h=500&fit=crop",
    category: "Bezel Set",
    metal: "18K White Gold",
    shape: "Princess"
  },
  {
    id: 9,
    name: "Bella Halo Oval",
    price: 3200,
    image: "https://images.pexels.com/photos/3266700/pexels-photo-3266700.jpeg?auto=compress&cs=tinysrgb&w=500&h=500&fit=crop",
    category: "Halo",
    metal: "18K Rose Gold",
    shape: "Oval"
  },
  {
    id: 10,
    name: "Caroline Solitaire Round",
    price: 2875,
    image: "https://images.pexels.com/photos/265906/pexels-photo-265906.jpeg?auto=compress&cs=tinysrgb&w=500&h=500&fit=crop",
    category: "Solitaire",
    metal: "18K Yellow Gold",
    shape: "Round"
  },
  {
    id: 11,
    name: "Diana Bezel Emerald",
    price: 2650,
    image: "https://images.pexels.com/photos/707046/pexels-photo-707046.jpeg?auto=compress&cs=tinysrgb&w=500&h=500&fit=crop",
    category: "Bezel Set",
    metal: "Platinum",
    shape: "Emerald"
  },
  {
    id: 12,
    name: "Elena Ring Radiant",
    price: 3100,
    image: "https://images.pexels.com/photos/1121985/pexels-photo-1121985.jpeg?auto=compress&cs=tinysrgb&w=500&h=500&fit=crop",
    category: "Embellished",
    metal: "18K Yellow Gold",
    shape: "Radiant"
  },
  {
    id: 13,
    name: "Florence Halo Princess",
    price: 3450,
    image: "https://images.pexels.com/photos/2735981/pexels-photo-2735981.jpeg?auto=compress&cs=tinysrgb&w=500&h=500&fit=crop",
    category: "Halo",
    metal: "18K White Gold",
    shape: "Princess"
  },
  {
    id: 14,
    name: "Grace Solitaire Emerald",
    price: 2175,
    image: "https://images.pexels.com/photos/3641056/pexels-photo-3641056.jpeg?auto=compress&cs=tinysrgb&w=500&h=500&fit=crop",
    category: "Solitaire",
    metal: "18K Rose Gold",
    shape: "Emerald"
  },
  {
    id: 15,
    name: "Harper Bezel Oval",
    price: 2890,
    image: "https://images.pexels.com/photos/5370804/pexels-photo-5370804.jpeg?auto=compress&cs=tinysrgb&w=500&h=500&fit=crop",
    category: "Bezel Set",
    metal: "18K Yellow Gold",
    shape: "Oval"
  },
  {
    id: 16,
    name: "Isabella Embellished Cushion",
    price: 3275,
    image: "https://images.pexels.com/photos/1616091/pexels-photo-1616091.jpeg?auto=compress&cs=tinysrgb&w=500&h=500&fit=crop",
    category: "Embellished",
    metal: "Platinum",
    shape: "Cushion"
  }
];

export const filterOptions = {
  look: ["Bezel Set", "Embellished", "Halo", "Solitaire"],
  metal: [
    { name: "18K Champagne Gold", color: "#D4AF37" },
    { name: "18K Rose Gold", color: "#B76E79" },
    { name: "18K White Gold", color: "#E8E8E8" },
    { name: "18K Yellow Gold", color: "#FFD700" },
    { name: "Platinum", color: "#E5E4E2" }
  ],
  shape: ["Asscher", "Cushion", "Elongated Cushion", "Emerald", "Marquise", "Old Mine Cushion", "Oval", "Pear", "Princess", "Radiant", "Round"]
};

export const sortOptions = [
  { value: "featured", label: "Featured" },
  { value: "best-selling", label: "Best Selling" },
  { value: "a-z", label: "Alphabetically: A-Z" },
  { value: "z-a", label: "Alphabetically: Z-A" },
  { value: "price-low", label: "Price: Low to High" },
  { value: "price-high", label: "Price: High to Low" },
  { value: "date-new", label: "Date: New to Old" },
  { value: "date-old", label: "Date: Old to New" }
];

export const navigation = {
  mainNav: [
    { name: "Engagement", href: "#", hasDropdown: true },
    { name: "Unisex Bands", href: "#", hasDropdown: true },
    { name: "Lifestyle", href: "#", hasDropdown: true },
    { name: "Loose Stones", href: "#", hasDropdown: false },
    { name: "Collections", href: "#", hasDropdown: true },
    { name: "Connect", href: "#", hasDropdown: true },
    { name: "Membership", href: "#", hasDropdown: false },
    { name: "In Stock Pieces", href: "#", hasDropdown: true }
  ]
};
